import React, { useState } from 'react';

import { Container } from '@components/Container';
import { Layout } from '@components/Layout';
import { bookingTermsOfUseJa, memberTermsOfUseJa } from '@data/termsOfUse';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';
import clsx from 'clsx';
import Color from 'color';

const strings = createStrings({
  ja: {
    title: 'ネット会員規約',
    bannerTitle: '利用規約',
    memberTermsOfUse: memberTermsOfUseJa,
    bookingTermsOfUse: bookingTermsOfUseJa,
    tabMember: 'FCSネット会員規約',
    tabUse: 'D2Dブッキング利用規約',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  title: {
    ...common.normalText,
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '42px',
    marginBottom: '6rem',
  },
  content: {
    ...common.normalText,
    whiteSpace: 'pre-wrap',
    '& b': {
      color: theme.palette.grey['800'],
    },
    '& span': {
      ...common.textPrimary,
    },
    color: theme.palette.grey['700'],
  },
  tabs: {
    ...common.flexInline,
    margin: '0 auto',
    marginTop: 20,
    columnGap: 20,
  },
  tab: {
    flex: 1,
    ...common.textAlignCenter,
    ...common.baseButton,
    background: theme.palette.primary.contrastText,
    padding: '18px 0px',
    '&$active': {
      background: Color(theme.palette.primary.main).alpha(0.1).toString(),
      color: theme.palette.primary.main,
    },
  },
  active: {},
  headerWrapper: {
    padding: '0 2rem',
    [theme.breakpoints.down('sm')]: {
      padding: '0 1rem',
    },
  },
}));

export const TermsOfUse: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Layout title={strings.title} breadcrumbs={['/utilities/Dashboard', '/about/TermsOfUse']}>
      <div className={classes.headerWrapper}>
        <div style={{ maxWidth: 1400, margin: '0 auto' }}>
          <div className={classes.tabs}>
            <button
              onClick={() => setTabIndex(0)}
              className={clsx(tabIndex === 0 && classes.active, classes.tab)}
            >
              {strings.tabMember}
            </button>
            <button
              onClick={() => setTabIndex(1)}
              className={clsx(tabIndex === 1 && classes.active, classes.tab)}
            >
              {strings.tabUse}
            </button>
          </div>
        </div>
      </div>

      <Container>
        <div className={classes.title}>{tabIndex === 0 ? strings.title : strings.tabUse}</div>
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{
            __html: tabIndex === 0 ? strings.memberTermsOfUse : strings.bookingTermsOfUse,
          }}
        />
      </Container>
    </Layout>
  );
};

export const meta: PageMeta = {
  title: strings.bannerTitle,
  order: 3,
};
